import { useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import {
  SectionTitle,
  TextBlock,
  Button,
  BusinessContactForm,
} from '@/ui/index';
import { ArrRight } from '@/icons/index';

import { ContentList } from '.';

import styles from './BusinessJoinUs.module.scss';

const Card = ({ data, onClick = () => null }) => {
  return (
    <article className={styles.card}>
      {data?.image && (
        <div className={styles['card__img-wrapper']}>
          <Image
            className={styles.card__img}
            src={data.image}
            alt={data?.title}
            title={data?.title}
            loading='lazy'
            layout='fill'
          />
        </div>
      )}
      <div className={styles.card__content}>
        {data?.title && (
          <strong className={styles.card__title}>{data.title}</strong>
        )}
        {data?.description && (
          <TextBlock
            className={classNames(
              styles.card__text,
              'text--medium',
              'text--shadow-black',
            )}
          >
            {data.description}
          </TextBlock>
        )}
        {data?.button_text && (
          <Button
            className={styles.card__button}
            onClick={() => onClick(data.id)}
          >
            {data.button_text}
            <ArrRight />
          </Button>
        )}
      </div>
    </article>
  );
};

const BusinessJoinUs = ({ data, className }) => {
  const [employee, setEmployee] = useState('');
  const [modalActive, setModalActive] = useState(false);

  const handleClick = (id) => {
    setModalActive(true);
    setEmployee(id);
  };

  const renderCard = (item, index) => (
    <Card data={item} onClick={handleClick} key={index} />
  );

  const closeModal = () => {
    setModalActive(false);
    setEmployee('');
  };

  return (
    <>
      {data?.cards && (
        <section
          className={classNames(
            styles['content-cards'],
            'wrapper section',
            className,
          )}
        >
          {data?.title && (
            <SectionTitle
              titleModify={classNames(
                styles['content-cards__title'],
                'title--large',
              )}
            >
              {data.title}
            </SectionTitle>
          )}
          {data?.cards && (
            <div className={styles['content-cards__inner']}>
              {data.cards.map(renderCard)}
            </div>
          )}
        </section>
      )}
      {data?.infoBlock && (
        <ContentList className='wrapper medium-margin' data={data.infoBlock} />
      )}
      <BusinessContactForm
        employeeID={employee}
        activeModal={modalActive}
        clearTariff={closeModal}
        hasEmployeesCount={true}
      />
    </>
  );
};

export default BusinessJoinUs;
